module.exports = __webpack_public_path__ + "img/guide_bg_m.152e26e9.png";